import React from "react";
import Landing from "./components/Landing/Landing";
import "bootstrap/dist/css/bootstrap.min.css";

import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Blogs from "./components/Blogs/Blogs";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import DVPN from "./components/DVPN/DVPN";
import Nodes from "./components/Nodes/Nodes";
import NebulaLight from "./components/NebulaLight/NebulaLight";
import ScrollTop from "./utils/ScrollTop";
import Map from "./Map";
import Buying from "./components/Buying/Buying";
import PaymentMethod from "./components/Buying/PaymentMethod";
import OrderConfirm from "./components/Buying/OrderConfirm";
import Tracking from "./components/Buying/Tracking";
import OurTeam from "./components/Landing/Teams/OurTeam";

function App() {
  return (
    <>
      <Router>
        <ScrollTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/dvpn" element={<DVPN />} />
          <Route path="/nodes" element={<Nodes />} />
          <Route path="/nebula-lite" element={<NebulaLight />} />
          <Route path="/buying" element={<Buying />} />
          <Route path="/payment" element={<PaymentMethod />} />
          <Route path="/order-confirm" element={<OrderConfirm />} />
          <Route path="/tracking-order" element={<Tracking />} />
          <Route path="/our-team" element={<OurTeam />} />

        </Routes>
      </Router>
    </>
  );
}

export default App;
